import React, {useEffect, useState} from 'react';
import {Modal, notification, Button, Collapse, Typography} from "antd";
import {notificationServices} from "../../../services/notification.services";
import i18n from "../../../i18n";

export default function NotificationMessage({notifications, setNeedUpdate, setStopListUpdate, loading}) {
  const {Panel} = Collapse;
  const {Paragraph} = Typography;

  const DIVIDER = '###CUT###';
  const [modalIndex, setModalIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const bigButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    borderColor: "#1CAA53"
  };
  useEffect(() => {
    if (notifications) {
      setVisible(true);
      setStopListUpdate(true);
    }
  }, [notifications]);

  if (setNeedUpdate) {
    setNeedUpdate(false);
  }

  if (loading) {
    return null;
  }

  const handleOk = (e) => {
    notificationServices.readNotification(notifications[modalIndex].id)
      .then((response) => {
        setStopListUpdate(true);
        notification.success({
                    message: i18n.t('components.notification.titles.readNotification.success'),
          description: response.message,
        });
        if (modalIndex < notifications.length - 1) {
          setModalIndex(modalIndex + 1);
        } else {
          setVisible(false);
          setStopListUpdate(false);

          if (setNeedUpdate) {
            setNeedUpdate(true);
          }
        }
      })
      .catch((error) => {
        notification.error({
                    message: i18n.t('components.notification.titles.readNotification.error'),
          description: error,
        });
        setVisible(false);
        setStopListUpdate(false);

        if (setNeedUpdate) {
          setNeedUpdate(true);
        }
      })
  }

  if (!notifications || !notifications.length) {
    return null;
  }

  return (
    <Modal
      title={i18n.t('modals.notificationMessage.title')}
      visible={visible}
      footer={null}
      onCancel={handleOk}
    >
      <div style={{width: "100%"}}>
        <p style={{whiteSpace: "pre-line", textAlign: "center"}}
           dangerouslySetInnerHTML={{__html: notifications[modalIndex].message.split(DIVIDER)[0]}}
        />
        {notifications[modalIndex].message.split(DIVIDER)[1] && notifications[modalIndex].message.split(DIVIDER)[1].length > 0 &&
          <Collapse className="notification-details" bordered={false} expandIconPosition={"right"}>
            <Panel header={i18n.t('main.buttons.detail')} key="1">
              <Paragraph copyable>{notifications[modalIndex].message.split(DIVIDER)[1]}</Paragraph>
            </Panel>
          </Collapse>
        }
      </div>
      <div className="center" style={{padding: "30px"}}>
        <Button type="primary" onClick={handleOk} style={bigButtonStyle}>OK</Button>
      </div>
    </Modal>);
}
